// @flow strict

import { Button, Modal } from 'antd';
import { useEffect, useState } from 'react';
import { IoFlash } from "react-icons/io5";
import useRemaining from '../../Hooks/useRemaining';
import { isRemainingExpired } from '../../Utility/utility';


const expiredMessage = "Your subscription has been expired. Please consider upgrading to unlock this feature.";
const accessMessage = "You have just discovered a feature available with our Pro Plan subscription. Please consider upgrading to unlock this feature.";

function AccessModal({ area }) {
  const [openExpireModal, setOpenExpireModal] = useState(false);
  const [openAccessModal, setOpenAccessModal] = useState(false);
  const { userInfo, remaining, expireDate } = useRemaining();

  useEffect(() => {
    if (remaining && userInfo?.role !== 'superadmin') {
      if (area in remaining && !remaining[area]) {
        setOpenAccessModal(true);
        setOpenExpireModal(false);
      } else if (isRemainingExpired(remaining?.expireDate || expireDate) === true) {
        setOpenExpireModal(true);
        setOpenAccessModal(false);
      };
    }
  }, [remaining, userInfo, expireDate, area]);

  return (
    // <Modal
    //   closable={true}
    //   footer={false}
    //   icon={<></>}
    //   open={openExpireModal || openAccessModal}
    //   onCancel={() => setOpenAccessModal(false)}
    // >
    //   <div className="p-3 p-lg-3 d-flex flex-column gap-2 token-warning-modal mt-3">
    //     <div className="d-flex justify-content-center">
    //       <p className="modal-icon fs-1 rounded-circle bg-primary-subtle">
    //         <IoFlash className="text-primary" />
    //       </p>
    //     </div>
    //     <h3 className="text-center">Upgrade Plan to Access This Features!</h3>
    //     <p className="fs-6 text-secondary text-center">
    //       {openExpireModal && expiredMessage}
    //       {openAccessModal && accessMessage}
    //     </p>
    //     <Button
    //       icon={<IoFlash />}
    //       type="primary"
    //       href="/pricing"
    //       size="large"
    //       className="text-decoration-none bg-primary shadow-sm"
    //     >
    //       Upgrade Pro
    //     </Button>
    //   </div>
    // </Modal >
    <>
    </>
  );
};

export default AccessModal;